module.exports = __webpack_public_path__ + "static/media/logo.bf39ff7e.webp";